/**
 * 租赁概况 API
 * 对应后端：RentalDashboardController（/rental/dashboard）
 * 权限：rental:dashboard:query
 */
import request from '@/config/axios'

export interface RentalDashboardOverviewVO {
  productCount?: number
  onShelfProductCount?: number
  orderCount?: number
  todayOrderCount?: number
  pendingCreditCount?: number
  pendingInvoiceCount?: number
  pendingTicketCount?: number
  pendingMerchantApplyCount?: number
}

export interface RentalDashboardTrendVO {
  labels?: string[]
  orderCounts?: number[]
  rentAmounts?: number[]
  periodRentAmount?: number
}

export interface RentalDashboardStatusItem {
  status?: string
  statusName?: string
  count?: number
}

export interface RentalDashboardStatusStatsVO {
  items?: RentalDashboardStatusItem[]
}

export const getOverview = () =>
  request.get<RentalDashboardOverviewVO>({ url: '/rental/dashboard/overview' })

export const getTrend = (days: 7 | 30 = 7) =>
  request.get<RentalDashboardTrendVO>({ url: '/rental/dashboard/trend', params: { days } })

export const getStatusStats = () =>
  request.get<RentalDashboardStatusStatsVO>({ url: '/rental/dashboard/status-stats' })
